// Copyright (c) 2019-24 Stax·ai, Inc.
// See LICENSE.md file in project root directory

import React from 'react';
import Tips from './Tips';

import '../../styles/modal.css';
import '../../styles/tips.css';

const formats = {
    "pdf": "PDF Document",
    "docx": "MS Word Document",
    "odt": "Open Document Text",
    "ppt": "MS Powerpoint File",
    "txt": "Standard Text File",
    "tiff": "TIFF Image/Doc",
    "jpg": "JPEG Image File",
    "png": "PNG Image File",
    "xls": "MS Excel Document",
};

export default class StackTips extends Tips {

    renderContent = () => {
        return (<div className="modal-content modal-center">
            {this.state.stage === 0 ? <>
                <h1>You've opened a stack!</h1>
                <strong>Drag and drop</strong> some documents in here, or <strong>click</strong> on the <u>Upload files</u> button to upload them.<br />
                Some of the supported file formats are:<br /><br />

                <div className="tips-stack-formats">
                    {Object.keys(formats).map((f,idx) => <div
                        key={idx}
                        className="tips-stack-formats-item"
                    >
                        <img
                            src={"https://static.stax.ai/images/format/" + f + ".png"}
                            alt={formats[f]}
                        />
                        <h2>{formats[f]}</h2>
                    </div>)}
                </div>

                <div style={{ clear: 'both', height: 20 }} />

                <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
            </> :
            
            this.state.stage === 1 ? <>
                <br />
                <h1>Actions on documents</h1>
                Once documents are in your stack, <strong>double-click</strong> them to open them!<br /><br />
                <img
                    style={{ width: 500 }}
                    src="https://static.stax.ai/images/graphics/guide-stack.png"
                    alt="Stack documents"
                /><br />
                <strong>Right-click</strong> on a document to see options.<br />
                Documents can be opened, moved, renamed, deleted, archived, sent, and much more!
                <br />
                <div className="welcome-next" onClick={this.nextStage}>Next ⇾</div>
            </> :
            
            this.state.stage === 2 ? <>
                <br />
                <h1>Selection and batch operations</h1>
                <strong>Click</strong> on a document to select it.<br />
                Select <u>multiple</u> documents using <span className="key">Ctrl</span> <strong>+ Click</strong>.<br />
                Select <u>a range</u> of documents using <span className="key">Shift</span> <strong>+ Click</strong>.
                <br /><br />
                <img
                    style={{ width: 500 }}
                    src="https://static.stax.ai/images/graphics/guide-select.png"
                    alt="Selecting documents"
                /><br /><br />
                <strong>Right-click</strong> selected documents for a list of batch operations like moving, deleting, or archiving them.<br />
                You can also see single and batch operations under <u>Actions</u> on the right side.<br />
                <div className="welcome-next" onClick={this.props.close}>Got it!</div>
            </> : ""}
        </div>);
    }

};